downloads-index
  .card
    .card-header
      h5
        i.feather.icon-map.mr-1
        | {opts.titles.download_orders}
    .card-block.row
      .col-12
        forms-orders-search-for-csv(tag-scope="forms_orders_search")
  .card
    .card-header
      h5
        i.feather.icon-map.mr-1
        | {opts.titles.download_products}
    .card-block.row
      .col-12
        forms-products-search(tag-scope="forms_products_search")
  .card
    .card-header
      h5
        i.feather.icon-box.mr-1
        | {opts.titles.download_locations}
    .card-block.row
      .col-12
        forms-locations-search(tag-scope="forms_locations_search")
  .card
    .card-header
      h5
        i.feather.icon-target.mr-1
        | {opts.titles.download_clients}
    .card-block.row
      .col-12
        forms-clients-search(tag-scope="forms_clients_search")
  script(type="typescript").
    this.mixin('base');
